import React from 'react';
import EditNote from '@mui/icons-material/RateReviewOutlined';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import PersonOutline from '@mui/icons-material/PersonOutline';
import Replay from '@mui/icons-material/Replay';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import {Message} from '@src/types/messages';
import './ChatFooter/InternalNotes.css';
export default function InternalActivity({message,showAuthor=true}:{message:Message;showAuthor?:boolean}) {
 const event=message.internal_event!;
 const time=<time>{new Date(Number(message.waba_payload?.timestamp)*1000).toLocaleTimeString('es-ES',{hour:'2-digit',minute:'2-digit'})}</time>;
 const Icon=message.id.startsWith('assignment:')?PersonOutline:event.text.startsWith('Reabierto')?Replay:event.text.startsWith('Resuelto')?CheckCircleOutline:InfoOutlined;
 let actor=event.actor||'',text=event.text;
 if(event.kind!=='note'){
  const resolution=/^(Resuelto|Reabierto) por (.+)$/.exec(text);
  if(resolution){actor=resolution[2];text=resolution[1]==='Resuelto'?'Conversación resuelta':'Conversación reabierta';}
  else if(message.id.startsWith('assignment:')&&text.includes(' · ')){const split=text.indexOf(' · ');actor=text.slice(0,split);text=text.slice(split+3);}
 }
 const ActivityIcon=event.kind==='note'?EditNote:Icon;
 return <div className="cv-activity"><div className="cv-activity-group">
  {actor&&showAuthor&&<div className="cv-activity-author">{actor}</div>}
  <article className={'cv-activity-card '+(event.kind==='note'?'cv-activity-note':'cv-activity-status')} aria-label={event.kind==='note'?'Nota interna · Solo equipo':'Cambio de estado'}>
   <ActivityIcon aria-hidden="true"/><span className="cv-activity-text">{text}{event.reason&&<> · {event.reason}</>}</span>{time}
  </article>
 </div></div>;
}
